import React, { useState } from "react";
import { Card } from "reactstrap";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Area, ReferenceLine } from "recharts";
import { DatePicker, Spin } from "antd";
import { LineChartOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useQuery } from "react-query";
import "../utils/style.css";
import { revenusYear, revenusYearByMerchant } from "../services/homeAdminApi";
const TurnOver = ({ title = "", selectedBusiness, selectedMarchand, setAmountForHome }) => {
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const { data: turnoverData = [], isLoading } = useQuery(
  ["turnover", selectedBusiness?.id, selectedMarchand, selectedYear],
  () => {
    if (selectedMarchand) {
      return revenusYearByMerchant(selectedMarchand, selectedYear);
    } else {
      return revenusYear(selectedYear);
    }
  },
  { enabled: true }
);
  const amount = turnoverData.reduce((sum, item) => sum + item.value, 0);

  // Dès que turnoverData change -> on met à jour Home
  React.useEffect(() => {
    if (typeof setAmountForHome === "function") {
      setAmountForHome(amount);
    }
  }, [amount, setAmountForHome]);
  const bestMonth =
    turnoverData.length > 0
      ? turnoverData.reduce((prev, current) => (prev.value > current.value ? prev : current)).month
      : null;
  const isAllZero = turnoverData.length > 0 && turnoverData.every((d) => d.value === 0);
  const handleChangeYear = (date) => {
    if (date) {
      const year = dayjs(date).year();
      setSelectedYear(year);
    }
  };
  return (
    <Card className="p-4 transfert-card" style={{ borderRadius: "10px",background:"#FFFFFF",border:'none' }}>
      <div className="d-flex justify-content-between align-items-center">
        <div style={{color:"#444444",fontFamily:"Poppins",fontSize:"15px",fontWeight:'500'}}>{title}</div>
        <DatePicker
          onChange={handleChangeYear}
          picker="year"
          value={dayjs(`${selectedYear}`)}
          allowClear={false}
          className="transfert-datepicker"
          style={{ width: window.innerWidth < 576 ? '100px' : '150px' }}
          disabledDate={(current) => current && current.year() > dayjs().year()}
        />
      </div>
    <div className="d-flex justify-content-between align-items-center mb-3"style={{color:"#44444480",fontFamily:"Poppins",fontSize:"13px",fontWeight:'400'}}>Total des ventes réalisées par l’ensemble des commerçants durant l’année</div>
      {isLoading ? (
        <div className="text-center py-5">
          <Spin size="large" />
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={window.innerWidth < 768 ? 250 : 300}>
          <LineChart data={turnoverData} margin={{ left: 20, right: 20 }}>
            <defs>
              <linearGradient id="colorBlue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#446CFF" stopOpacity={0.3} />
                <stop offset="100%" stopColor="#A9BAFF" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <CartesianGrid vertical={false} strokeDasharray="3 3" horizontal={!isAllZero} />
           <XAxis
            dataKey="month"
            interval={window.innerWidth < 768 ? 1 : 0} 
            angle={window.innerWidth < 768 ? -45 : 0} 
            textAnchor={window.innerWidth < 768 ? 'end' : 'middle'}
            padding={{ left: 20, right: 10 }}
            style={{ color: "#949494", fontFamily: "Poppins", fontSize: "13px", fontWeight: "400" }}
          />

            <YAxis style={{color:"#949494",fontFamily:"Poppins",fontSize:"13px",fontWeight:'400'}} />
            {bestMonth && !isAllZero && (
              <ReferenceLine
                x={bestMonth}
                stroke="#446CFF"
                strokeOpacity={0.15}
                strokeWidth={30}
              />
            )}
            <Tooltip
              contentStyle={{ backgroundColor: "#262626", color: "#FFFFFF", borderRadius: "6px" }}
              labelFormatter={(label) => `Mois : ${label}`}
              formatter={(val) => [`${val.toLocaleString()} XOF`, { title }]}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#3761FF"
              fill="url(#colorBlue)"
              fillOpacity={1}
            />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#3761FF"
              strokeWidth={3}
              dot={{ r: 5, fill: "#fff", stroke: "#3761FF", strokeWidth: 2 }}
              activeDot={{ r: 8, fill: "#3761FF", stroke: "#fff", strokeWidth: 3 }}
            />
            {isAllZero && (
              <foreignObject x="0" y="50" width="100%" height="200">
                <div className="transfert-empty-message">
                  <LineChartOutlined className="transfert-empty-icon animate-pulse" />
                  <p className="transfert-empty-title">Aucune donnée disponible</p>
                  <small className="transfert-empty-subtext">
                    Aucun {title} pour <strong>{ "ce business"}</strong> en <strong>{selectedYear}</strong>
                  </small>
                </div>
              </foreignObject>
            )}
          </LineChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
};
export default TurnOver;
